const React = require('react');
const ReactIntl = require('react-intl');
const { Card, Link, Text, Modal, ModalContent, ModalHeader } = require('@metro-ui/core');
const { includes, partial } = require('lodash');
const { checkCodesViaSmsTOTPTimestamp } = require('../../utils/Utils');
const defaultMessages = require('../../i18n/messages/default.js');
const AppConstants = require('../../constants/AppConstants');

const { injectIntl } = ReactIntl;

class AuthMethodsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCodesViaSmsOption: true
    }
  }

  componentDidMount() {
    this.setState({ showCodesViaSmsOption: checkCodesViaSmsTOTPTimestamp() });
  }

  renderSecurityLevelIcon(safetyLevel) {
    return (
      <img className="safety-level" alt='safety level' src={`assets/images/safety_icon_${safetyLevel}.png`} />
    )

  }

  renderAuthMethodsModalList() {
    const { intl, mfaOptions, userAuthenticationMethod, onSelectionChange, userType } = this.props;
    const link_via_webauthn = this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.how_it_works_url']);

    return (
      <div className="authMethods-modal">
        <Text
          className="subtitle"
          size={{ l: "medium", xl: "medium", s: "small", xs: "medium" }}
          hasNoNativeMargin
        >
          {intl.formatMessage(defaultMessages['loginpreferences.2famethods.auth_methods.subtitle'])}
        </Text>
        {(includes(mfaOptions, AppConstants.LoginPreferences.TWO_FA_WEB_AUTHN_OPTION_MAP)
          || userAuthenticationMethod == AppConstants.TWO_FA_WEB_AUTHN) &&
          <Card className="card" padding="medium" onClick={partial(onSelectionChange, 'optViaFingerprint')}>
            <div className="title-container">
              <Text
                className="title"
                color="metro-blue"
                size={{ l: "medium", xl: "medium", s: "small", xs: "medium" }}
                hasNoNativeMargin
              >
                {intl.formatMessage(defaultMessages['loginpreferences.2famethods.auth_methods.via_device.title']).toUpperCase()}
              </Text>
              {this.renderSecurityLevelIcon('very_high')}
            </div>
            <Text size="small" hasNoNativeMargin>
              {intl.formatMessage(defaultMessages['loginpreferences.2famethods.auth_methods.via_device.description'])}
            </Text>
            <Text size="small" hasNoNativeMargin>
              <Link href={AppConstants.Links.HOW_IT_WORKS} target="_blank" onClick={(e) => e.stopPropagation()}>
                {intl.formatMessage(defaultMessages['loginpreferences.2famethods.how_it_works'])}
              </Link>
            </Text>
          </Card>
        }
        {(includes(mfaOptions, AppConstants.LoginPreferences.TWO_FA_TOTP_APP_OPTION_MAP)
          || userAuthenticationMethod == AppConstants.TWO_FA_TOTP_APP) &&
          <Card className="card" padding="medium" onClick={partial(onSelectionChange, 'otpGeneratorApp')}>
            <div className="title-container">
              <Text
                className="title"
                color="metro-blue"
                size={{ l: "medium", xl: "medium", s: "small", xs: "medium" }}
                hasNoNativeMargin
              >
                {intl.formatMessage(defaultMessages['loginpreferences.2famethods.auth_methods.via_app.title']).toUpperCase()}
              </Text>
              {this.renderSecurityLevelIcon('very_high')}
            </div>
            <Text size="small" hasNoNativeMargin>
              {intl.formatMessage(defaultMessages['loginpreferences.2famethods.auth_methods.via_app.description'])}
            </Text>
            <Text size="small" hasNoNativeMargin>
              <Link href={AppConstants.Links.HOW_IT_WORKS} target="_blank" onClick={(e) => e.stopPropagation()}>
                {intl.formatMessage(defaultMessages['loginpreferences.2famethods.how_it_works'])}
              </Link>
            </Text>
          </Card>
        }
        {((includes(mfaOptions, AppConstants.LoginPreferences.TWO_FA_TOTP_SMS_OPTION_MAP)
          || userAuthenticationMethod == AppConstants.TWO_FA_TOTP) && this.state.showCodesViaSmsOption === true) &&
          <Card className="card" padding="medium" onClick={partial(onSelectionChange, 'otpViaSms')}>
            <div className="title-container">
              <Text
                className="title"
                color="metro-blue"
                size={{ l: "medium", xl: "medium", s: "small", xs: "medium" }}
                hasNoNativeMargin
              >
                {intl.formatMessage(defaultMessages['loginpreferences.2famethods.auth_methods.via_sms.title']).toUpperCase()}
              </Text>
              {this.renderSecurityLevelIcon('low')}
            </div>
            <Text size="small" hasNoNativeMargin>
              {intl.formatMessage(defaultMessages['loginpreferences.2famethods.auth_methods.via_sms.description'])}
            </Text>
            <Text size="small" hasNoNativeMargin>
              <Link href={userType === "SUPP" ? AppConstants.Links.HOW_IT_WORKS : link_via_webauthn} target="_blank" onClick={(e) => e.stopPropagation()}>
                {intl.formatMessage(defaultMessages['loginpreferences.2famethods.how_it_works'])}
              </Link>
            </Text>
          </Card>
        }
      </div>
    );
  }

  render() {
    const { intl, closeModal } = this.props;
    return (
      <Modal
        aria-labelledby="modal-title"
        isOpen
        onDismiss={closeModal}
      >
        <ModalHeader
          align="end"
          isClosable
          padding="medium"
          spacing="medium"
        >
          <Text
            size="large"
            color="metro-blue"
            hasNoNativeMargin
          >
            {intl.formatMessage(defaultMessages['loginpreferences.2famethods.auth_methods.title'])}
          </Text>
        </ModalHeader>
        <ModalContent
          direction="column"
          padding="large"
          spacing="medium"
        >
          {this.renderAuthMethodsModalList()}
        </ModalContent>
      </Modal>
    );
  }
}

module.exports = injectIntl(AuthMethodsModal);
